var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.expiryDate)?_c('div',{class:{
    [_vm.$style.blueContainer]: !_vm.isExpired,
    [_vm.$style.redContainer]: _vm.isExpired,
  }},[_c('TimerIcon',{class:_vm.$style.timerIcon}),_vm._v(" "+_vm._s(_vm.expiryDateDisplay)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }